import { render, staticRenderFns } from "./commandForm.vue?vue&type=template&id=38efb940&scoped=true&"
import script from "./commandForm.vue?vue&type=script&lang=js&"
export * from "./commandForm.vue?vue&type=script&lang=js&"
import style0 from "./commandForm.vue?vue&type=style&index=0&id=38efb940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38efb940",
  null
  
)

export default component.exports